import React from "react";
import { Router, Switch, Route } from "react-router-dom";
import PageNotFound from "../components/PageNotFound";
import { HomePage } from "src/components/Home";
import { ArchivedProjectsContainer } from "src/containers/ArchivedProjectsContainer";
import { ProjectContainer } from "src/containers/ProjectContainer";
import { ProposalContainer } from "src/containers/ProposalContainer";
import { LoginContainer } from "src/containers/LoginContainer";
import { ProtectedRoutes } from "src/components/ProtectedRoutes";
import { ProjectsContainer } from "src/containers/ProjectsContainer";
import { ProposalsListContainer } from "src/containers/ProposalsListContainer";
import history from "src/plugins/history";
import StorePage from "src/components/Store";
import DownloadableMediasContainer from "src/containers/DownloadableMediasContainer";
import { UserInfosContainer } from "src/containers/UserInfosContainer";
import { UserAccountContainer } from "src/containers/UserAccountContainer";
import PrintProvider from "react-easy-print";
export const AppRouter = () => (
  <PrintProvider loose={true}>
    <Router history={history}>
      <Switch>
        <ProtectedRoutes
          exact={true}
          path="/projects/:id"
          component={props => {
            return (
              <ProjectContainer
                projectId={parseInt(props.match.params.id, 10)}
              />
            );
          }}
        />
        <ProtectedRoutes exact={true} path="/" component={HomePage} />
        <ProtectedRoutes
          exact={true}
          path="/projects/:id/prestation/:prestationId/proposal/:proposalUuid"
          component={props => (
            <ProposalContainer
              projectId={parseInt(props.match.params.id, 10)}
              proposalUuid={props.match.params.proposalUuid}
              prestationId={parseInt(props.match.params.prestationId, 10)}
            />
          )}
        />
        <ProtectedRoutes
          exact={true}
          path="/projects/:id/prestation/:prestationId"
          component={props => (
            <ProposalsListContainer
              projectId={parseInt(props.match.params.id, 10)}
              prestationId={parseInt(props.match.params.prestationId, 10)}
            />
          )}
        />
        <ProtectedRoutes
          exact={true}
          path="/profil"
          component={UserInfosContainer}
        />
        <ProtectedRoutes
          exact={true}
          path="/account"
          component={UserAccountContainer}
        />
        <ProtectedRoutes
          exact={true}
          path="/library"
          component={ArchivedProjectsContainer}
        />
        <ProtectedRoutes
          exact={true}
          path="/library/projects/:id"
          component={props => (
            <DownloadableMediasContainer
              projectId={parseInt(props.match.params.id, 10)}
            />
          )}
        />
        <ProtectedRoutes
          exact={true}
          path="/projects"
          component={ProjectsContainer}
        />

        <ProtectedRoutes exact={true} path="/store" component={StorePage} />
        <Route exact={true} path="/login" component={LoginContainer} />
        <Route exact={false} component={PageNotFound} />
      </Switch>
    </Router>
  </PrintProvider>
);



// WEBPACK FOOTER //
// ./src/router/index.tsx